/**
 * Yvine Design — article page (event add-to-calendar).
 * Cached asset, initialised once per [data-art="article"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('article', function (root) {
    // ---- Poster lightbox: click = full size, hover warms the big file ----
    var hero = root.querySelector('[data-hero-zoom]');
    if (hero) {
      var small = hero.querySelector('img');
      var big = hero.getAttribute('data-full') || '';
      // The poster used to be pre-fetched on hover. It is the largest file on
      // the site, and a mouse crossing the page pulled it — on top of the copy
      // the page had already downloaded. Now nothing is fetched until the
      // picture is actually opened, and usually not even then: ArtLightbox.pick
      // opens the copy already on the page whenever that is big enough.
      hero.addEventListener('click', function () {
        if (!window.ArtLightbox) return;
        var full = window.ArtLightbox.pick(small, big);
        if (!full) return;
        window.ArtLightbox.open({ media: [{ kind: 'image', url: full, thumb: full }], title: small ? small.alt : '' });
      });
    }

    // ---- Registration QR: a picture pasted alone right under an e-mail line is
    // the payment / sign-up QR. Sit it tight under the address and give it the
    // address's exact width (owner's request 2026-09-11) — the base
    // `img { width: 100% }` otherwise blows the pasted picture up to the column.
    var body = root.querySelector('.art-post__body');
    if (body) {
      var mailRe = /[\w.+-]+@[\w-]+\.[\w.-]+/;
      function fitQr() {
        Array.prototype.forEach.call(body.querySelectorAll('img'), function (img) {
          var wrap = img.parentElement;
          if (!wrap || wrap === body || wrap.children.length !== 1 || wrap.textContent.trim()) return;
          var prev = wrap.previousElementSibling;
          while (prev && !prev.textContent.trim() && !prev.querySelector('img')) prev = prev.previousElementSibling;
          if (!prev || prev.querySelector('img')) return;
          var line = prev.textContent.trim();
          if (line.length > 80 || !mailRe.test(line)) return;
          var range = document.createRange();
          range.selectNodeContents(prev);
          var w = range.getBoundingClientRect().width;
          if (!w) return;
          img.classList.add('art-post__qr');
          img.style.setProperty('--qr-w', Math.round(w) + 'px');
        });
      }
      fitQr();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitQr); // remeasure once the webfont is in
    }

    var panel = root.querySelector('[data-event-panel]');
    if (!panel) return;
    var btn = panel.querySelector('[data-add-cal]');
    if (!btn) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function icsStamp(d) {
      return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + 'Z';
    }
    function icsEscape(s) { return String(s).replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n'); }

    btn.addEventListener('click', function () {
      var title = panel.getAttribute('data-title') || 'Event';
      var url = panel.getAttribute('data-url') || '';
      var loc = panel.getAttribute('data-location') || '';
      var start = new Date(panel.getAttribute('data-start'));
      var endRaw = panel.getAttribute('data-end');
      var end = endRaw ? new Date(endRaw) : new Date(start.getTime() + 2 * 60 * 60 * 1000);
      if (isNaN(start.getTime())) return;
      var absUrl = url.indexOf('http') === 0 ? url : window.location.origin + url;

      var ics = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Yvine Design//Events//EN',
        'CALSCALE:GREGORIAN',
        'BEGIN:VEVENT',
        'UID:' + (panel.getAttribute('data-id') || Date.now()) + '@yvine',
        'DTSTAMP:' + icsStamp(new Date()),
        'DTSTART:' + icsStamp(start),
        'DTEND:' + icsStamp(end),
        'SUMMARY:' + icsEscape(title),
        'LOCATION:' + icsEscape(loc),
        'DESCRIPTION:' + icsEscape(absUrl),
        'URL:' + absUrl,
        'END:VEVENT',
        'END:VCALENDAR'
      ].join('\r\n');

      var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = (title.replace(/[^\w\- ]+/g, '').trim() || 'event') + '.ics';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    });
});
